<template>
  <div class="role-page full-height">
    <table-con>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{path: '/orders/orderList'}">{{ $t('common.home') }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ $t('fund.fundDetail') }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="search">
        <el-row class="search-row" style="padding: 0px">
          <el-col :span="6" class="display-row">
            <div class="query-title">{{ $t('fund.tradeStartDate') }}:</div>
            <div class="flex1">
              <el-date-picker clearable v-model="queryInfo.createTimeStart" type="date" size="small" format="yyyy-MM-dd"
                value-format="yyyy-MM-dd" :placeholder="$t('common.selectDate')"></el-date-picker>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title">{{ $t('fund.tradeEndDate') }}:</div>
            <div class="flex1">
              <el-date-picker clearable v-model="queryInfo.createTimeEnd" type="date" size="small" format="yyyy-MM-dd"
                value-format="yyyy-MM-dd" :placeholder="$t('common.selectDate')"></el-date-picker>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title" style="text-align: right">{{ $t('fund.relationOrderNo') }}:</div>
            <div class="flex1">
              <el-input :placeholder="$t('common.pleaseInput')" clearable v-model="queryInfo.orderNo" size="small"
                @keyup.enter.native="searchList"></el-input>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title" style="text-align: right">{{ $t('fund.tradeType') }}:</div>
            <div class="flex1">
              <el-select v-model="queryInfo.typeDetail" :placeholder="$t('common.pleaseSelect')" size="small" clearable>
                <el-option v-for="item in tradeTypeList()" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="6" class="display-row" style="margin-top: 10px;">
            <div class="query-title" style="text-align: right">{{ $t('fund.tradeNo') }}:</div>
            <div class="flex1">
              <el-input :placeholder="$t('common.pleaseInput')" clearable v-model="queryInfo.tradingNo" size="small"
                @keyup.enter.native="searchList"></el-input>
            </div>
          </el-col>
          <el-col :span="6" class="display-row" style="margin-top: 10px;">
            <div class="query-title" style="text-align: right">{{ $t('saledFeedback.addTemplate19') }}:</div>
            <div class="flex1">
              <el-select v-model="queryInfo.payStatus" :placeholder="$t('common.pleaseSelect')" size="small" clearable>
                <el-option v-for="item in payStatusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="6" class="display-row" style="margin-top: 10px;">
            <div class="query-title">{{ $t("createOrder.createOrder102") }}:</div>
            <div class="flex1">
              <el-input :placeholder="$t('common.pleaseInput')" clearable v-model="queryInfo.userName" size="small"
                @keyup.enter.native="searchList"></el-input>
            </div>
          </el-col>
        </el-row>
        <el-row class="search-row" style="padding: 0px;margin-top: 10px;">
          <el-col :span="24" class="display-row">
            <div style="text-align: right; width: 100%; padding-right: 10px; floate: right">
              <el-button class="search-btn btn-gray" @click="queryInfoClear">{{ $t('common.reset') }}</el-button>
              <el-button class="search-btn btn-blue" @click="searchList">{{ $t('common.search') }}</el-button>
              <el-button class="search-btn btn-blue" @click="exportCapitalRecordList">{{ $t("export") }}</el-button>
              <el-button class="search-btn btn-green" @click="toRecharge">{{ $t('fund.recharge') }}</el-button>
              <el-button class="search-btn btn-green" @click="toRechargeList">{{ $t('fund.rechargeLog') }}</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <div slot="table" class="full-height display-col">
        <el-table :header-cell-style="tableStyle.headerStyle" :cell-style="tableStyle.cellStyle" :data="recordList" border stripe
          height="550" :row-style="{height: '40px'}" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="45" align="center"></el-table-column>
          <el-table-column type="index" align="center" :label="$t('wzbg.wz6')" width="60"></el-table-column>
          <el-table-column align="center" width="90" :label="$t('handle')">
            <template v-slot="scope">
              <!-- <el-button v-if="scope.row.payStatus === '0'" class="search-btn btn-gray" @click="quxiao(scope.row)">{{ $t('cancel') }}</el-button> -->
              <!-- <el-button v-if="scope.row.payStatus === '0'" class="search-btn btn-blue" @click="zhifu(scope.row)">{{ $t('fba.pay') }}</el-button> -->
              <el-button v-if="showView(scope.row)" class="search-btn btn-blue" style="margin-right: 0 !important" @click="toDetails(scope.row)">{{ $t('orderList.orderList146') }}</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="tradingNo" align="center" width="130" :label="$t('fund.tradeNo')" show-overflow-tooltip>
          </el-table-column>
          <el-table-column width="130" prop="orderNo" align="center" :label="$t('fund.relationOrderNo')">
            <template v-slot="scope">
              <el-tooltip effect="dark" :content="scope.row.orderNo" placement="top">
                <div slot="content" style="max-width: 300px; line-height: 1.5; word-break: break-all;">{{ scope.row.orderNo }}</div>
                <div class="cell-ellipsis" @click="handleOrderNo(scope.row)" :class="{ 'tradingNo': scope.row.orderNo && scope.row.orderNo.toLowerCase().startsWith('p') }">{{ scope.row.orderNo }}</div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="orderNo" align="center" :label="$t('createOrder.createOrder102')">
            <template v-slot="scope">
              {{ scope.row.userName }}
            </template>
          </el-table-column>
          <el-table-column prop="clientManagerUserName" align="center" :label="$t('cnumber.cnumber30')">
            <template v-slot="scope">
              {{ scope.row.clientManagerUserName }}
            </template>
          </el-table-column>
          <el-table-column prop="createTime" sortable align="center" width="160" :index="indexMethod" :label="$t('fund.tradeTime')">
            <template v-slot="scope">
              <span class="create-time">{{ formatCreateTime(scope.row.createTime) }}</span>
            </template>
          </el-table-column>
          <el-table-column min-width="100" prop="paymentMethod" align="center" width="120" :label="$t('fund.paymentMethod')">
            <template v-slot="{ row }">
              {{ paymentMethod(row.paymentMethod) }}
            </template>
          </el-table-column>
          <el-table-column min-width="100" prop="orderNo" align="center" :label="$t('saledFeedback.addTemplate19')">
            <template v-slot="scope">
              {{ setStatus(scope.row.payStatus) }}
            </template>
          </el-table-column>
          <el-table-column min-width="100" prop="dealDesc" align="center" :label="$t('fund.tradeIntro')"></el-table-column>
          <el-table-column width="110" prop="typeDetail" sortable align="center" :index="indexMethod" :label="$t('fund.tradeType')">
            <template v-slot="scope">
              {{ typeDetailShow(scope.row.typeDetail) }}
            </template>
          </el-table-column>
          <el-table-column width="100" prop="money" sortable align="center" :index="indexMethod" :label="$t('fund.amount') + '(元)'">
            <template v-slot="scope">
              <div class="money-col-content">
                <span>{{ moneyShow(scope.row.moneyFlag, scope.row.money) }}</span>
                <el-tooltip v-if="['5', '7'].includes(scope.row.paymentMethod)" :content="moneyCalc(scope.row)" placement="top">
                  <span class="text-row-1">{{ moneyCalc(scope.row) }}</span>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="exchangeRate" width="90" align="center" :label="$t('recharge.exchangeRate')">
            <template v-slot="scope">
              {{ scope.row.exchangeRate || scope.row.exchangeRate === 0 ? scope.row.exchangeRate : '-' }}
            </template>
          </el-table-column>
          <el-table-column width="100" prop="balance" sortable align="center" :index="indexMethod" :label="$t('fund.balance') + '(元)'">
            <template v-slot="scope">
              {{ scope.row.balance || scope.row.balance === 0 ? formatThousands(scope.row.balance) : '' }}
            </template>
          </el-table-column>
          <el-table-column width="140" prop="customerRemark" align="center" :label="$t('common.remark')">
            <template v-slot="{ row }">
              <el-tooltip style="width: 100%;" :content="row.customerRemark" placement="top" effect="light" :disabled="!row.customerRemark" :open-delay="300">
                <el-input class="remark-input" type="textarea" resize="none" style="width: 100%;" @change="updateRemark($event, row)" v-model="row.customerRemark" size="mini">
                </el-input>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pageNum"
          :page-sizes="[5, 10, 20, 50, 100, 200]" :pager-count="5" :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      </div>
    </table-con>
    <PayRechargeDialog
      v-if="payRechargeMounted"
      ref="payRechargeDialog"
      :bank-submit-handler="submitOrderBillBankPay"
      @balance-pay="handleBalancePay"
      @paypal-success="paypalSuccess"
      @success="onPayRechargeSuccess"
      @view-recharge-log="toRecharge"
    />
  </div>
</template>

<script>
import tableCon from '../../views/tableContainer';

import { formatThousands } from "@/assets/js/utils";
import { getRouteQueryCache, setRouteQueryCache } from "@/assets/js/routeQueryCache";
import PayRechargeDialog from "@/components/PayDialog/PayRechargeDialog.vue";

export default {
  components: { tableCon, PayRechargeDialog },
  data () {
    return {
      formatThousands,
      isClientManage: this.$store.state.isClientManage,
      queryInfo: {
        userName: '',
        tradingNo: '',
        orderNo: '',
        createTimeStart: '',
        createTimeEnd: '',
        typeDetail: '',
        payStatus: undefined,
        pageSize: 10,
        pageNum: 1,
      },
      orderDateRangeValue: [],
      recordList: [],
      total: 0,
      multipleSelection: [],
      payStatusOptions: [
        { value: '0', label: this.$t('saledFeedback.addTemplate24') },
        { value: '1', label: this.$t('saledFeedback.addTemplate20') },
        { value: '2', label: this.$t('saledFeedback.addTemplate21') },
        { value: '3', label: this.$t('saledFeedback.addTemplate26') },
      ],
      payRechargeMounted: false
    };
  },
  methods: {
    restoreQueryState () {
      const cache = getRouteQueryCache('funding');
      if (cache && cache.queryInfo) {
        this.queryInfo = { ...this.queryInfo, ...cache.queryInfo };
      }
    },
    saveQueryState () {
      setRouteQueryCache('funding', {
        queryInfo: this.queryInfo,
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    setStatus (status) {
      if (status === '0') {
        return this.$t('saledFeedback.addTemplate24');
      } else if (status === '1') {
        return this.$t('saledFeedback.addTemplate20');
      } else if (status === '2') {
        return this.$t('saledFeedback.addTemplate21');
      } else if (status === '3') {
        return this.$t('saledFeedback.addTemplate26');
      }
    },
    paymentMethod(status) {
			switch (status) {
				case '1':
					return this.$t('fund.balance');
				case '2':
					return this.$t('recharge.alipay');
				case '3':
					return this.$t('recharge.wechat');
				case '4':
					return 'paypal'
        case '5':
          return `paypal + ${this.$t('fund.balance')}`
        case '6':
          return this.$t('fund.bankPay')
        case '7':
          return `${this.$t('fund.bankPay')} + ${this.$t('fund.balance')}` 
				default:
					return '-'
			}
		},
    async queryPay(row) {
      try {
        const res = await this.$http.post(
            "cmUser/capitalRecord/pay",
            { tradingNo: row.tradingNo }
        )
        if (res.data.code === 200 || res.data.code === 10151) {
          if(!res.data.data.balance){
            this.$store.dispatch("setOrderCount");
            this.$message({
              type: 'success',
              message: res.data.message,
            });
            this.searchList ()
          }
        }
      } catch (error) {
        this.$message({
          type: 'info',
          message: this.$t('orderList.orderList168')
        });
      }
    },
    paypalSuccess() {
      this.searchList()
    },
    handleBalancePay({ data }) {
      this.queryPay({ tradingNo: data.tradingNo })
    },
    onPayRechargeSuccess() {
      this.searchList()
    },
    submitOrderBillBankPay({ rechargeDto, payDialogData, paySubmitData }) {
      return this.$http.post('bankCard/orderBillPay', {
        rechargeDto,
        tradingNo: payDialogData.tradingNo,
        payType: paySubmitData.payType,
        balanceAmount: paySubmitData.balanceMoney,
        thirdPayAmount: paySubmitData.money,
      })
    },
    openPayRechargeDialog(data, closeDetail) {
      this.payRechargeMounted = true
      this.$nextTick(() => {
        this.$refs.payRechargeDialog.openPayDialog({ data, closeDetail })
      })
    },
    quxiao (row, cancelReason) {
      // console.log(row)
      this.$confirm(this.$t('saledFeedback.addTemplate23'), this.$t('prompt.title'), {
        confirmButtonClass: 'form-btn btn-blue',
        cancelButtonClass: 'form-btn btn-gray',
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(async () => {
        const res = await this.$http.post(
            "cmUser/capitalRecord/cancel",
            { tradingNo: row.tradingNo, cancelReason }
        )
        if (res.data.code === 200) {
          this.$store.dispatch("setOrderCount");
          this.$message({
            type: 'success',
            message: res.data.message,
          });
          this.searchList ()
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('orderList.orderList168')
        });
      });
    },
    indexMethod (index) {
      return (this.pageNum - 1) * this.pageSize + index + 1;
    },
    formatCreateTime (value) {
      const formatted = this.$options.filters.dateFormatToSecond(value);
      return formatted ? formatted.replace(' ', '\n') : '';
    },
    handleSizeChange (newSize) {
      this.queryInfo.pageSize = newSize;
      this.getrecordList();
    },
    handleCurrentChange (newPage) {
      this.queryInfo.pageNum = newPage;
      this.getrecordList();
    },
    orderDateRange () { },
    toRecharge () {
      this.$router.push({
        name: 'recharge',
      });
    },
    toRechargeList () {
      this.$router.push({
        name: 'RechargeList',
      });
    },
    searchList () {
      //查询
      this.queryInfo.pageNum = 1;
      this.getrecordList();
    },
    async getrecordList () {
      console.log(this.queryInfo);
      const { data: res } = await this.$http.get('cmUser/capitalRecord/list', { params: this.queryInfo });
      console.log(res);
      this.recordList = res.data.list;
      this.total = res.data.total;
    },
    async exportCapitalRecordList () {
      if (this.multipleSelection.length === 0) {
        this.$message.warning(this.$t('saledFeedback.exportDataTip'));
        return;
      }
      const ids = this.multipleSelection.map(item => item.tradingNo).join(',');
      this.$http({
        url: 'cmUser/capitalRecord/exportCapitalRecordList',
        method: 'get',
        params: { ...this.queryInfo, idsList: ids },
        responseType: 'blob', // 表明返回服务器返回的数据类型
        headers: {
          'Content-Type': 'application/json'
        },
        data: {
          //接口参数
        }
      }).then((res) => {
        //创建一个隐藏的a连接，
        const link = document.createElement('a');
        let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
        link.style.display = 'none';
        //设置连接
        link.href = URL.createObjectURL(blob);
        link.download = '资金明细.xlsx';
        document.body.appendChild(link);
        //模拟点击事件
        link.click();
      }).catch((err) => {
        // console.log(err);
      })
    },
    queryInfoClear () {
      //清空
      this.queryInfo = {
        createTimeStart: '',
        createTimeEnd: '',
        tradingNo: '',
        orderNo: '',
        typeDetail: '',
        userName: '',
        payStatus: undefined,
        pageSize: 10,
        pageNum: 1,
      };
      this.orderDateRangeValue = [];
    },
    typeDetailShow (status) {
      switch (status) {
        case '1':
          return this.$t('fund.recharge');
        case '2':
          return this.$t('fund.fund7');
        case '2+':
          return this.$t('fund.fund13');
        case '3':
          return this.$t('fund.payOrder');
        case '4':
          return this.$t('fund.compensate');
        case '5':
          return this.$t('fund.deduct');
        case '6':
          return this.$t('fund.withdrawal');
        case '7':
          return this.$t('fund.fund1');
        case '8':
          return this.$t('fund.fund2');
        case '9':
          return this.$t('fund.fund3');
        case '10':
          return this.$t('fund.fund7');
        case '11':
          return this.$t('fund.fund5');
        case '12':
          return this.$t('fund.fund6');
        case '13':
          return this.$t('fund.fund8');
        case '14':
          return this.$t('fund.fund9');
        case '15':
          return this.$t('fund.fund10');
        case '16':
          return this.$t('fund.fund12');
        case '16+':
          return this.$t('fund.fund11');
        case '17':
          return this.$t('orderList.orderList11');
        case '18':
          return this.$t('fund.fund18');
        case '21':
          return this.$t('fund.fund21');
        case '20':
          return this.$t('fund.fund20');
      }
    },
    moneyShow (moneyFlag, money) {
      switch (moneyFlag) {
        case '1':
          return '+' + formatThousands(money);
        case '0':
          return '-' + formatThousands(money);
      }
    },
    moneyCalc(row) {
      const { thirdPayAmount, balancePayAmount } = row;
      const thirdPay = thirdPayAmount !== null ? formatThousands(thirdPayAmount) : '-';
      const balancePay = balancePayAmount !== null ? formatThousands(balancePayAmount) : '-';
      return `(${thirdPay} + ${balancePay})`
    },
    showView(row) {
      const showStatus = ['0', '1', '3'].includes(row.payStatus);
      const hideOrder = row.orderNo ? row.orderNo.toLowerCase().startsWith('p') : showStatus;
      return showStatus && !hideOrder
    },
    tradeTypeList () {
      return [
        { value: '1', label: this.$t('fund.recharge') },
        { value: '2', label: this.$t('fund.fund7') },
        // { value: '2+', label: this.$t('fund.fund13') },
        // { value: '3', label: this.$t('fund.payOrder') },
        { value: '4', label: this.$t('fund.compensate') },
        { value: '5', label: this.$t('fund.deduct') },
        { value: '6', label: this.$t('fund.withdrawal') },
        { value: '7', label: this.$t('fund.fund1') },
        { value: '8', label: this.$t('fund.fund2') },
        { value: '9', label: this.$t('fund.fund3') },
        // { value: '10', label: this.$t('fund.fund7') },
        // { value: '11', label: this.$t('fund.fund5') },
        { value: '12', label: this.$t('fund.fund6') },
        { value: '13', label: this.$t('fund.fund8') },
        { value: '14', label: this.$t('fund.fund9') },
        { value: '15', label: this.$t('fund.fund10') },
        // { value: '16', label: this.$t('fund.fund12') },
        // { value: '16+', label: this.$t('fund.fund11') },
        { value: '21', label: this.$t('fund.fund21') },
        // { value: '20', label: this.$t('fund.fund20') },
      ];
    },
    toDetails (row) {
      this.$modalDialog(() => import('./fundingDetails.vue'), {
        row,
        onCancelPay: (r, reason) => this.quxiao(r || row, reason),
        onPay: (data, closeDetail) => {
          this.openPayRechargeDialog(data, closeDetail)
        }
      }).then(
          () => {
            // 成功重新拉取数据
            this.searchList()
          },
          () => {
          }
      )
    },
    async updateRemark (val, row) {
      await this.$http.post("/cmUser/capitalRecord/updateRemark", {
        id: row.id,
        customerRemark: row.customerRemark
      })
    },
    handleOrderNo(rowData) {
      if(rowData.orderNo.toLowerCase().startsWith('p')) {
				this.$router.push({
					path: '/FBA',
					query: {
						containerBatchNo: rowData.orderNo
					},
				});
			}
    }
  },
  watch: {
    //监听时间选择器绑定值变化
    orderDateRangeValue () {
      //解决时间选择器清空后 绑定值为null问题
      if (!this.orderDateRangeValue) {
        this.orderDateRangeValue = [];
        this.queryInfo.createTimeStart = '';
        this.queryInfo.createTimeEnd = '';
      } else {
        if (this.orderDateRangeValue.length > 0) {
          this.queryInfo.createTimeStart = this.orderDateRangeValue[0];
          this.queryInfo.createTimeEnd = this.orderDateRangeValue[1];
        }
      }
    },
  },
  beforeRouteLeave (to, from, next) {
    this.saveQueryState();
    next();
  },
  created () {
    this.restoreQueryState();
    this.getrecordList();
  },
};
</script>

<style lang="less" scoped>
.role-page > .search-container {
  height: 60px !important;
}

.el-table .el-button--small {
  padding: 4px 10px;
}
.query-title {
  width: 100px;
}
.query-title2 {
  width: 120px;
  text-align: right;
  margin-top: 5px;
  margin-right: 5px;
}
.search-btn {
  padding-left: 5px !important;
  padding-right: 5px !important;
}
.tradingNo{
  cursor: pointer;
  color: #1481d1;
}
.money-col-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.create-time {
  display: inline-block;
  line-height: 20px;
  text-align: center;
  white-space: pre-line;
}
.remark-input /deep/ .el-input__inner {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
